<div class="environment-banner" [ngClass]="banner.class" *ngFor="let banner of banners">
    <span class="float-left">{{ banner.text }}</span>
    <span class="float-right">
        <a *ngFor="let action of banner.actions" (click)="actionClicked($event, action)" href="{{ action.href || '#' }}">
            {{ action.text }}
        </a>
    </span>
    <div class="clearfix"></div>
</div>
